module.exports = __webpack_public_path__ + "static/img/shankarg1.bb2b517.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shankarg1.jpg
// module id = 18
// module chunks = 0